var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPTextMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.74707C0.5 0.91707 1.171 0.24707 2 0.24707H14C14.829 0.24707 15.5 0.91707 15.5 1.74707V10.7401C15.5 11.5701 14.829 12.2401 14 12.2401H8.167L4.3 15.1371C4.22572 15.1928 4.13738 15.2267 4.0449 15.2351C3.95242 15.2434 3.85945 15.2258 3.77639 15.1843C3.69334 15.1428 3.62349 15.0789 3.57467 14.9999C3.52586 14.9209 3.5 14.8299 3.5 14.7371V12.2391H2C1.171 12.2391 0.5 11.5691 0.5 10.7391V1.74707ZM4.5 4.24407H11.5V5.24407H4.5V4.24407ZM4.5 7.24207H9.5V8.24207H4.5V7.24207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPTextMessage);
export default __webpack_public_path__ + "static/media/p_text_message.5f4f23fe79299c4ba8d7aa664f9a7d14.svg";
export { ForwardRef as ReactComponent };